<div class="amt-footer-content w-100 d-flex justify-content-center position-relative">
    <span class="amt-footer-copy text-center">&copy; 2026 Aathreya Machine Tools. All rights reserved.</span>
    <span class="amt-footer-designer position-absolute" style="right: 0;">Designed & Developed by <strong><a
                href="https://www.cktechsoln.in/" target="_blank" class="text-light">CKTech
                Solution Pvt Ltd.</a></strong></span>
</div>